import { newImport } from '@/utils/index.js'

export default [
  // 基金详情
  {
    path: '/fundMarket',
    name: 'FundMarket',
    component: () => newImport('fund/fundMarket')
  },
  // 基金详情
  {
    path: '/fund/fundDetail',
    name: 'FundDetail',
    component: () => newImport('fund/fundDetail'),
    meta: {
      title: 'Fund Details',
      routeList: [
        {
          name: 'Home',
          url: '/home'
        },
        {
          name: 'Fund Details',
          url: '/fund/fundDetail'
        }
      ]
    }
  }
]



// WEBPACK FOOTER //
// ./src/routers/module/fund.js